import styled from 'styled-components';

export const InputSubtitle = styled.span`
    color: ${({ isActive }) => isActive ? '#505154' : '#B5B5B5'};
    font-size: 14px;
    font-weight: bold;
    text-align: center;
`;

export const Column = styled.div`
    width: ${({ width }) => width};
    margin: ${({ margin }) => margin || 0};
    display: flex;
    flex-direction: column;
`;
